
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Créer un site Internet de carreleur : exemples, prix et délais",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Internet est un lieu de rencontre entre des internautes qui saisissent des requêtes et d’autres internautes qui apportent des solutions.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Créer un site Internet de carreleur : exemples, prix et délais",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Internet est un lieu de rencontre entre des internautes qui saisissent des requêtes et d’autres internautes qui apportent des solutions.",
        },
      ],
    };
  },
};
